import BasicCard from './BasicCard';

export default BasicCard;
export * from './BasicCard';
